module.exports = __webpack_public_path__ + "static/media/kh.27ceade7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/kh.png
// module id = 1895
// module chunks = 0